import { getTestId } from "./Url";

export const getIsExampleExercise = (testId?: string): boolean => {
    return (
        process.env.REACT_APP_EXAMPLE_TEST_ID === getTestId() ||
        (testId !== undefined && process.env.REACT_APP_EXAMPLE_TEST_ID === testId)
    );
};
